// extracted by mini-css-extract-plugin
export default {"descriptionList":"qY_qZ","descriptionList__item":"qY_q0"};